import styled from "styled-components";
import { TABLE_COMPANY_SOLUTIONS_LIST } from "@utils/constants";

export const AnalyticalNotesListContainer = styled.section`
  max-width: ${(props) =>
    props.type === TABLE_COMPANY_SOLUTIONS_LIST ? "1511px" : "1532px"};
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  // box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const HeaderWrapper = styled.div`
  background-color: #004c83;
  display: flex;
  justify-content: space-between;
  padding: 18px 30px;
`;

export const Title = styled.h2`
  color: white;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0;
  font-weight: normal;
  text-transform: uppercase;
`;

export const AddAnalyticalNotes = styled.button`
  background-color: transparent;
  border: 1px solid white;
  border-radius: 4px;
`;
